import { EXTERNAL_LOYALTY_PARTNERS } from "../../data/constants/shared";
import { defineProfile } from "./defaultProfile";

/**
 * Dotpe — the first-party loyalty partner. Legacy **class 3**.
 *
 * 🔴 **`isExternalLoyalty` is `true` as of 2026-09-09 (DM-146), and it used to be `false`.** The
 * old value was the legacy classification carried over faithfully: `isExternalProviderC1C2C3`
 * (which includes this partner) gated the `requestId` stamping, while `isExternalLoyaltyProvider`
 * (which did not) gated the offers fetch and the removal unblock — so a DotPe CRM coupon
 * travelled the ORDINARY coupon path and came off the bill without ever being released at the
 * provider. The comment that used to sit here called that out as looking like an oversight and
 * named `isExternalLoyalty: true` as the whole fix. It was, and this is it.
 *
 * ⚠️ `requiresCouponUnblock` moved with it, and is NOT a second opinion about class 3. The app's
 * real gate is `isExternalLoyaltyProvider` (`removeDiscountFromCart` → `removeExternalDiscount`),
 * which reads `EXTERNAL_LOYALTY_PROVIDER_METAIDS` — DotPe is in that list now, so the release
 * fires for it, and a profile that said otherwise would be describing behaviour the app does not
 * have. `__tests__/providers.test.ts` ties both flags to that constant.
 *
 * The narrower class-1 guard inside `removeExternalDiscount` — reference id AND phone must both
 * be present — is `unblockRequiresReferenceAndPhone`, which stays `false` here.
 *
 * ⚠️ `hasCouponModal` stays `false` too: an offers leg is not the coupon modal. Before that field
 * existed (2026-09-25) the modal's gate was this same external list, so it opened for DotPe.
 */
export const dotpeProfile = defineProfile(EXTERNAL_LOYALTY_PARTNERS.DOTPE, {
  sendsRequestId: true,
  isExternalLoyalty: true,
  requiresCouponUnblock: true,
});
